export default "__VITE_ASSET__C9q9VzVj__"